import { JSX } from "react";
import { maxLength, required, TextInput } from "react-admin";
import { useWatch } from "react-hook-form";

/**
 * A Nok website's sender description: the general line a customer chooses from when picking a
 * Mystery Shopper sender. Required for a company website, which is never offered without one
 * (HQ-API's `NokWebsiteImporter` applies the same rule). Shared by the create and edit forms.
 */
export const SenderDescriptionInput: () => JSX.Element = (): JSX.Element => {
    const soloOrCompany: string | undefined = useWatch({ name: 'soloOrCompany' });
    const validate = soloOrCompany === 'company' ? [required(), maxLength(255)] : [maxLength(255)];

    return (
        <TextInput source="senderDescription"
                   label="Sender Description"
                   multiline
                   rows={ 3 }
                   fullWidth
                   validate={ validate }
                   helperText="Shown to customers choosing a Mystery Shopper sender. Keep it general: never the name, address or anything that identifies the website." />
    );
};
